exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".ctaButton[data-v-ca6ada68] {\n  background-color: #FFFFFF !important;\n  border: 1px solid #18A0FB !important;\n  border-radius: 5px;\n  color: #18A0FB !important;\n}\n.ctaButton[data-v-ca6ada68]:hover {\n  background-color: #18A0FB !important;\n  color: #FFFFFF !important;\n}", ""]);

// exports
